import { render, staticRenderFns } from "./formContractClientEE.vue?vue&type=template&id=bf85053c&"
import script from "./formContractClientEE.vue?vue&type=script&lang=js&"
export * from "./formContractClientEE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports